import { getType, isNoE } from '@/utils/obj-utils';
import { getCurrentAlpha2Code } from '@/utils/site-utils';
import { eq } from '@/utils/string-utils';

export const decimalToHex = (decimal) => {
  return decimal.toString(16);
};
export const hexToDecimal = (hex) => {
  return parseInt(hex, 16);
};
export const formatMoney = (money, currency = 'EUR') => {
  const type = getType(money);
  if (type !== '[object Number]') money = Number(money);
  let locale = getCurrentAlpha2Code() ?? 'NL';
  if (eq(locale, 'SE')) locale = 'sv-SE';
  if (eq(locale, 'DK')) locale = 'da-DK';
  if (isNoE(money) || isNaN(money) || isNoE(currency)) return null;
  const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
  return formatter.format(money).replace(/^[a-z]*\$[a-z]*/gi, '$');
};
export function formatPrice(number) {
  if (typeof number === 'number' && !isNaN(number)) {
    // 先将数字保留两位小数
    const formattedNumber = number.toFixed(2);

    // 使用正则表达式添加千分位分隔符
    return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return '';
  }
}

export const getCurrencySymbol = (currency = 'EUR') => {
  return formatMoney(0, currency).replace(/[0-9a-z.\s,]*/gi, '');
};
export const toThousands = (number) => {
  const type = getType(number);
  if (type !== '[object Number]') number = Number(number);
  if (isNaN(number)) return '';
  let locale = getCurrentAlpha2Code() ?? 'nl-NL';
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumSignificantDigits: 2,
  });
  return formatter.format(number);
};
export const sum = (array, key = null) => {
  let result = 0;
  for (let item of array) {
    const num = key ? item[key] : item;
    if (!isNaN(num)) {
      result += Number(num);
    }
  }
  return result;
};
export const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};
